import { ChevronDownIcon } from '@ui/components/icons';
import { cn } from '@ui/lib/utils';

interface CollapsibleChevronProps extends React.SVGProps<SVGSVGElement> {
  open: boolean;
}

const CollapsibleChevron = ({ open, className, ...props }: CollapsibleChevronProps) => (
  <ChevronDownIcon
    data-slot="collapsible-chevron"
    className={cn('size-4 transition-transform', !open && '-rotate-90', className)}
    {...props}
  />
);

export { CollapsibleChevron };
